// Sample data for testing template variable replacement
export const sampleTemplateData = {
	TITLE: 'Revolutionary AI Technology Transforms Digital Marketing',
	CONTENT: `
		<p>In a groundbreaking development that's reshaping the digital marketing landscape, 
		new artificial intelligence technology is enabling businesses to create more personalized 
		and effective advertising campaigns than ever before.</p>
		
		<p>The innovative system analyzes user behavior patterns and preferences to deliver 
		highly targeted content that resonates with individual consumers, resulting in 
		significantly improved engagement rates and conversion metrics.</p>
		
		<p>Industry experts predict this technology will become the new standard for 
		digital advertising within the next two years, fundamentally changing how brands 
		connect with their audiences.</p>
	`,
	metaDescription:
		'Discover how revolutionary AI technology is transforming digital marketing with personalized campaigns and improved engagement rates.',
}

/**
 * Replaces template variables (e.g., {{TITLE}}, {{CONTENT}}) with actual values
 * @param template - The template string containing variables
 * @param data - Object containing the replacement values
 * @returns The template with variables replaced
 */
export const replaceTemplateVariables = (
	template: string,
	data: Record<string, string> = sampleTemplateData,
): string => {
	return template.replace(/\{\{(\w+)\}\}/g, (match, key: string) => {
		const replacement = data[key]
		return replacement ?? match // Keep original if no replacement found
	})
}

/**
 * Renders a complete template by replacing variables in both HTML and CSS
 * @param html - Template HTML with variables
 * @param css - Template CSS with variables
 * @param data - Data to replace variables with
 * @returns Object with rendered HTML and CSS
 */
export const renderTemplate = (html: string, css: string, data: Record<string, string> = sampleTemplateData) => {
	return {
		html: replaceTemplateVariables(html, data),
		css: replaceTemplateVariables(css, data),
	}
}
